import { render } from "./AI.vue?vue&type=template&id=d51b759a&scoped=true"
import script from "./AI.vue?vue&type=script&lang=js"
export * from "./AI.vue?vue&type=script&lang=js"

import "./AI.vue?vue&type=style&index=0&id=d51b759a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d51b759a"

export default script